import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../../components/CustomComponent.js";
import { report_receipt_tax, report_receipt } from "../../../components/Report.js"
export default class PaymentLists extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,

      filter_search: "",
      filter_payment_type: "",
      filter_start_date: "",
      filter_end_date: "",

      data: [],
      count: 10,
      data_bank: [],

      id: "",
      uid: "",
      bank_name: "",
      account_number: "",
      account_name: "",
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    const {
      filter_search,
      filter_payment_type,
      filter_start_date,
      filter_end_date,
    } = this.state;
    let data, count, data_bank;
    loading(true);
    let [result, result_bank] = await Promise.all([
      GET("admin/sales/list-payment", {
        page: page,
        data_search: filter_search,
        start_date: filter_start_date,
        end_date: filter_end_date,
        payment_type: filter_payment_type,
      }),
      GET("admin/setting/banks/list", { page: 0, data_search: "" }),
    ]);
    if (result?.status) {
      data = result.data;
      count = result.count;
    }
    if (result_bank?.status) {
      data_bank = result_bank.data
        .map((e) => ({
          value: e.id,
          label: `${e.bank_name} : ${e.account_number} (${e.account_name})`,
          is_default: e.is_default, // เก็บไว้ใช้ sort
        }))
        .sort((a, b) => (b.is_default === true) - (a.is_default === true));
    }
    this.setState({
      data,
      count,
      data_bank,
    });
    loading(false);
  };
  Print = async (uid, document_no, item, type) => {
    loading(true);
    const { data_bank } = this.state;
    const _transfer_bank_account = data_bank.find(
      (e) => e.value === item.transfer_bank_account
    );
    const _credit_bank_account = global.bank.find(
      (e) => e.value === item.credit_bank_account
    );
    Swal.fire({
      title: "พิมพ์เอกสาร",
      text: "",
      html: `
        <div class="w-100">
          <button id="report-receipt-tax" class="btn btn-outline-dark w-100 mb-3 text-start">
            <span class="icon me-2">&#xf15b;</span>
            ใบเสร็จรับเงิน/ใบกำกับภาษี
          </button>
          <button id="report-receipt" class="btn btn-outline-dark w-100 mb-3 text-start">
            <span class="icon me-2">&#xf15b;</span>
            ใบเสร็จรับเงิน
          </button>
        </div>`,
      showConfirmButton: false,
      showCancelButton: false,
      showCloseButton: true,
      didOpen: () => {
        document.getElementById("report-receipt-tax").addEventListener("click", () => {
          report_receipt_tax(uid, {
            type: type,
            cash_amount: item.cash_amount,
            transfer_amount: item.transfer_amount,
            transfer_bank_account: _transfer_bank_account?.label || "",
            transfer_date: item.transfer_date,
            transfer_time: item.transfer_time,
            credit_amount: item.credit_amount,
            credit_bank_account: _credit_bank_account?.label || "",
            credit_date: item.credit_date,
            check_number: item.check_number,
          });
        });

        document.getElementById("report-receipt").addEventListener("click", () => {
          report_receipt(uid, {
            type: type,
            cash_amount: item.cash_amount,
            transfer_amount: item.transfer_amount,
            transfer_bank_account: _transfer_bank_account?.label || "",
            transfer_date: item.transfer_date,
            transfer_time: item.transfer_time,
            credit_amount: item.credit_amount,
            credit_bank_account: _credit_bank_account?.label || "",
            credit_date: item.credit_date,
            check_number: item.check_number,
          });
        });
      },
    });
    loading(false);
  };
  render() {
    const {
      modal_create,
      modal_update,
      filter_search,
      filter_payment_type,
      filter_start_date,
      filter_end_date,
      data,
      count,
      id,
      uid,
      bank_name,
      account_number,
      account_name,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div className="d-flex justify-content-between">
              <h4 className="fw-bold mb-3 me-3">ประวัติชำระเงิน</h4>
            </div>
            <div className="d-flex flex-wrap align-items-center">
              <input
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                placeholder="ค้นหา..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_search}
              />
              <select
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_payment_type: e.target.value });
                }}
                value={filter_payment_type}
              >
                <option value="">เลือกวิธีชำระเงิน</option>
                <option value="เงินสด">เงินสด</option>
                <option value="เงินโอน">เงินโอน</option>
                <option value="เครดิต/เช็ค">เครดิต/เช็ค</option>
              </select>
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_start_date: e.target.value });
                }}
                value={filter_start_date}
              />
              <span className="px-2 me-2 mb-2">ถึง</span>
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_end_date: e.target.value });
                }}
                value={filter_end_date}
              />
              <div className="d-flex">
                <button
                  className="btn btn-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  ค้นหา
                </button>
                <button
                  className="btn btn-outline-dark px-3 me-2 mb-2"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  ล้างค่า
                </button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table rounded-3 overflow-hidden table-hover">
                <thead>
                  <tr>
                    <td className="text-nowrap">วันที่</td>
                    <td className="text-nowrap">รหัสเอกสาร</td>
                    <td className="text-nowrap">เลขใบแจ้งหนี้</td>
                    <td className="text-nowrap">เลขใบวางบิล</td>
                    <td className="text-nowrap">ชื่อลูกค้า</td>
                    <td className="text-nowrap">โกดังสินค้า</td>
                    <td className="text-nowrap">วิธีการชำระ</td>
                    <td className="text-nowrap text-end">จำนวนเงิน</td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr>
                      <td className="text-nowrap">
                        {item.created_at ? format_date(item.created_at) : ""}
                      </td>
                      <td className="text-nowrap">
                        {item.sale?.document_no ||
                          item.repair?.document_no ||
                          "-"}
                      </td>
                      <td className="text-nowrap">
                        {item.sale?.invoice?.document_no ||
                          item.sale?.invoice[0]?.document_no ||
                          item.repair?.invoice?.document_no ||
                          "-"}
                      </td>
                      <td className="text-nowrap">
                        {item.sale?.invoice?.billing_note?.document_no ||
                          item.repair?.invoice?.billing_note?.document_no ||
                          item.billing_note?.document_no ||
                          "-"}
                      </td>
                      <td className="text-nowrap">
                        {item.sale?.customer?.full_name ||
                          item.repair?.customer?.full_name ||
                          item.billing_note?.customer?.full_name ||
                          ""}
                      </td>
                      <td className="text-nowrap">
                        {item.sale?.warehouse?.name ||
                          item.repair?.warehouse?.name ||
                          ""}
                      </td>
                      <td className="text-nowrap">
                        <div className="d-flex">
                          {Number(item.cash_amount) !== 0 && (
                            <div className="mx-1">
                              {Status("สด", "success")}
                            </div>
                          )}
                          {Number(item.transfer_amount) !== 0 && (
                            <div className="mx-1">
                              {Status("โอน", "warning")}
                            </div>
                          )}
                          {Number(item.credit_amount) !== 0 && (
                            <div className="mx-1">
                              {Status("เครดิต/เช็ค", "primary")}
                            </div>
                          )}
                        </div>
                      </td>
                      <td className="text-nowrap text-end">
                        {toFixed(
                          Number(item.cash_amount) +
                            Number(item.transfer_amount) +
                            Number(item.credit_amount)
                        )}
                      </td>
                      <td className="text-center align-middle wpx-100">
                        <div className="d-flex">
                          <BtnIcon
                            type="print"
                            onClick={() => {
                              if (item.sale) {
                                this.Print(
                                  item.sale?.uid,
                                  item.sale?.document_no,
                                  item,
                                  ""
                                );
                              } else if (item.repair) {
                                this.Print(
                                  item.repair?.uid,
                                  item.repair?.document_no,
                                  item,
                                  "repair"
                                );
                              } else if (item.billing_note) {
                                this.Print(
                                  item.billing_note?.uid,
                                  item.billing_note?.document_no,
                                  item,
                                  "billing-notes"
                                );
                              }
                            }}
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-2">
            <Pagination
              className="mb-3"
              count={Math.ceil(count / 10) || 1}
              showFirstButton
              showLastButton
              onChange={(_, page) => this.Get(page)}
            />
          </div>
        </div>
      </div>
    );
  }
}
